import React, { useState } from 'react'
import {
    Dialog,
    DeleteButton
} from '../../Elements'

import { Classes } from '@blueprintjs/core'

const ConfirmDeletionRenderer = (props) => {
    const {
        children,
        handleDeleteSubmit,
        handleFileClick,
        url
    } = props

    const [deletionDialogState, setDeletionDialogState] = useState(
        {
            isOpen: true,
            fileId: null,
            fileName: null,
            documentKey: null
        })

    const closeDeletionDialog = () => {
        setDeletionDialogState({
            isOpen: false,
            fileId: null,
            fileName: null,
            documentKey: null
        })
    }

    return (
        <>
            <Dialog
                icon='trash'
                title='Delete?'
                isOpen={deletionDialogState.isOpen}
                canOutsideClickClose={true}
                canEscapeKeyClose={true}
                isCloseButtonShown={true}
                onClose={closeDeletionDialog}
            >
                <div className={Classes.DIALOG_BODY}>
                    <p>{`Are you sure you want to delete ${deletionDialogState.fileName|| 'this selection'}? This cannot be undone.`}</p>
                    <DeleteButton onClick={handleDeleteSubmit} />
                </div>
            </Dialog>

            <a
                href={url}
                download="download"
                onClick={handleFileClick}
            >
                {children}
            </a>
            {/* <div>
                <button onClick={handleDeleteSubmit}>Confirm</button>
            </div> */}
        </>
    )
}

export default ConfirmDeletionRenderer